import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Glyphicon, Row, Col } from 'react-bootstrap';
import Pagination from './Pagination';
import FontAwesome from 'react-fontawesome';
import { withNamespaces } from 'react-i18next';
import BlockUi from 'react-block-ui';

class PagedEntitiesGrid extends Component {
    constructor(props) {
        super(props);
        this.handlePageSelect = this.handlePageSelect.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }

    handlePageSelect(selectedPage) {
        const { onFetchData, sortKey, sortDirection, pageSize } = this.props;
        onFetchData({
            sortKey,
            sortDirection,
            pageNumber: selectedPage,
            pageSize
        });
    }

    handleSort(selectedSortKey) {
        const { onFetchData, sortKey, sortDirection, pageNumber, pageSize } = this.props;
        let selectedSortDirection = 'asc';
        if (selectedSortKey === sortKey) {
            selectedSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
        }
        onFetchData({
            sortKey: selectedSortKey,
            sortDirection: selectedSortDirection,
            pageNumber,
            pageSize
        });
    }

    render() {
        const { t, itemsPerRow, data, itemComponent, loading, total, pages, pageNumber = 1, pageSize = 10 } = this.props;

        return <BlockUi blocking={loading}>
            <Row>
                <Col sm={12 / itemsPerRow}>
                    {data.map(item => itemComponent(item))}
                </Col>
            </Row>
            {total > 0 && <Row>
                <Col sm={5}>
                    <div className='table-stats text-muted'>
                        <b>{t('List_PaginationStats', { first: (pageNumber - 1) * pageSize + 1, last: Math.min(pageNumber * pageSize, total), total })}</b>
                    </div>
                </Col>
                <Col sm={7}>
                    <div className='table-pagination'><Pagination totalPages={pages} currentPage={pageNumber} onChange={this.handlePageSelect} /></div>
                </Col>
            </Row>}
        </BlockUi>;
    }
}

PagedEntitiesGrid.propTypes = {
    columns: PropTypes.arrayOf(PropTypes.shape({
        header: PropTypes.string,
        sortable: PropTypes.bool,
        accessor: PropTypes.string,
        cell: PropTypes.func
    })),
    itemsPerRow: PropTypes.number,
    onFetchData: PropTypes.func,
    data: PropTypes.array,
    loading: PropTypes.bool,
    sortKey: PropTypes.string,
    sortDirection: PropTypes.string,
    total: PropTypes.number,		// total number of records
    pages: PropTypes.number,		// number of pages
    pageNumber: PropTypes.number,
    pageSize: PropTypes.number
};

export default withNamespaces()(PagedEntitiesGrid);